// Piezas de marcado compartidas por los paneles: escapado, insignia de línea y textos de tiempo.

import { LIGHT_LINES } from "../config";

export function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

// «HOSPITAL VINALOPO» → «Hospital Vinalopo».
export function titleCase(s: string): string {
  return s
    .toLowerCase()
    .replace(/(^|[\s.\-/(])(\p{L})/gu, (_m, p: string, c: string) => p + c.toUpperCase());
}

// Insignia cuadrada con la letra de la línea en su color (texto oscuro en colores claros).
export function badge(line: string, color: string, size: "s" | "m" | "l" = "m"): string {
  const light = LIGHT_LINES.has(line) || /^#(f|e)[0-9a-f]f/i.test(color);
  return `<i class="badge ${size}${light ? " lt" : ""}" style="--c:${escapeHtml(color)}">${escapeHtml(line)}</i>`;
}

export function minutesText(min: number): string {
  return min <= 0 ? "Llegando" : `${min} min`;
}
